import { removeToken } from "..";

export const SairDoSistema = (): void => {
    removeToken();
}
